import React from "react";
import { FaArrowRight } from "react-icons/fa";

const CustomRightArrow = () => {
  return (
    <div className="relative xl:top-20 lg:top-16 md:top-5 sm:top-20">
      <FaArrowRight className="cursor-pointer" />
    </div>
  );
};

export default CustomRightArrow;
